const INITIAL_STATE = {
  waiverFilter: '',
  selectedWaiver: 0
};

export const waiversReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_ADMIN_WAIVERS_PAGE_FILTER_STRING':
      return {
        ...state,
        waiverFilter: action.payload
      };
    case 'UPDATE_ADMIN_WAIVERS_PAGE_SELECTED_WAIVER':
      return {
        ...state,
        selectedWaiver: action.payload
      };
    default:
      return state;
  }
};
